import React from 'react'
import assets from '../utils/assets';
import styles from "../pages/pages.module.scss";

const CfoService = () => {
  return (
    <img src={assets.cfoservices} alt="" className={`img-fluid ${styles.mHeight194}`} />
  )
}

export default CfoService;